module.exports = __webpack_public_path__ + "img/guide.5fe862aa.png";